import { useEffect, useState } from "react";

// Punto de corte simple: por debajo de esto, el chat deja de ir "al lado"
// en paralelo (no cabe junto a la cuadrícula/tabla) y pasa a ser un panel
// que se abre/cierra con un botón flotante.
const MOBILE_BREAKPOINT = 860;

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < MOBILE_BREAKPOINT : false
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return isMobile;
}
